import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';


class StartPage extends Component {
    state = {
        textInput: ''
    }
    handleClick = () => {
        if (this.state.textInput.length == 0) {
            alert('Input is empty');
            return;
        }
        this.props.history.push({
            pathname: '/play',
            state: { words: this.state.textInput }
        })
    };
    handleChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    };

    render() {
        return (
            <div className="start-page">
                <h1 className="start-page__title">
                    Read
                    <span className="focused"> faster</span>
                    , word per word, more
                    <span className="focused"> efficient </span>
                    and
                    <span className="focused"> focused. </span>
                </h1>

                <div className="start-page__container">
                    <p>Paste your text below 👇</p>
                    <textarea type="text" placeholder="Your text ..." className="start-page__textarea" id="textInput" onChange={this.handleChange}></textarea>
                    <div className="start-page__button" onClick={this.handleClick}>Start reading</div>

                </div>
            </div>
        );
    }
}


export default withRouter(StartPage);







// WEBPACK FOOTER //
// ./src/Components/StartPage.jsx